import styled, { useTheme } from 'styled-components';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { BodyMedium, Heading4Text } from '../../../components/Texts';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';
import {
  BREAKPOINT_BANNER_CREATE_GIFT_CLICKED,
  BREAKPOINT_BANNER_MAYBE_LATER_CLICKED,
  sendEvent,
} from '../../../common/analytics';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    margin-top: auto;
    flex-direction: column;
  }
`;

const Image = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  max-height: 60vh;
  object-fit: contain;
  object-position: center;
`;

const BreakpointRaffleModal = ({ onClose }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const theme = useTheme();
  const navigate = useNavigate();

  const image = `/breakpoint/raffle-${isMobile ? 'mobile' : 'desktop'}.webp`;

  const title = 'Gift to participate';

  const description = 'Each gift sent = one entry to win $1,000.';

  return (
    <Modal onClose={onClose}>
      <FullHeightModalContent>
        <div style={{ display: 'flex', gap: 6, flexDirection: 'column' }}>
          <Heading4Text
            style={{
              fontWeight: '600',
              textAlign: 'center',
              color: theme.text.title,
            }}
          >
            {title}
          </Heading4Text>
          <BodyMedium
            style={{
              color: theme.text.regular,
              textAlign: 'center',
            }}
          >
            {description}
          </BodyMedium>
        </div>
        <Image src={image} />
        <ButtonContainer>
          <Button
            variant='white'
            fullWidth={isMobile}
            onClick={() => {
              sendEvent(BREAKPOINT_BANNER_MAYBE_LATER_CLICKED);
              onClose();
            }}
          >
            Maybe later
          </Button>
          <Button
            fullWidth={isMobile}
            onClick={async () => {
              sendEvent(BREAKPOINT_BANNER_CREATE_GIFT_CLICKED);
              navigate('/app/gifts/create');
              onClose();
            }}
          >
            Gift to enter
          </Button>
        </ButtonContainer>
      </FullHeightModalContent>
    </Modal>
  );
};

export default BreakpointRaffleModal;
